import React, { PureComponent } from 'react';
import { Item, Icon, Label } from 'semantic-ui-react';

import { getProgramColor } from '../utils/data-parser';

export default class PersonalDetails extends PureComponent {
  render() {
    const { data } = this.props;
    return (
      <Item>
        <Item.Content>
          <Item.Header as="h4">
            <a href={data.analyticsLink} target="_blank" rel="noopener noreferrer">
              {data.name}
            </a>
          </Item.Header>

          <Item.Meta>
            <a href={'mailto:' + data.email}>
              <Icon name="mail outline" />
            </a>{' '}
            | {data.phone}
          </Item.Meta>
          <Item.Meta>
            <Label basic content={data.region ? data.region : 'NA'} color="black" />
            <Label
              basic
              content={
                data.state === 'ACT'
                  ? 'Active'
                  : data.state === 'INACT'
                  ? 'Archived'
                  : 'Trial'
              }
              color={
                data.state === 'ACT' ? 'olive' : data.state === 'INACT' ? 'teal' : 'black'
              }
            />
            <Label
              basic
              color={getProgramColor(data._id.program, data.current_program)}
              content={data._id.program}
            />
          </Item.Meta>
        </Item.Content>
      </Item>
    );
  }
}
